<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/adminCarriers/">Carriers</a></li>
      <li class="breadcrumb-item active" aria-current="page">Gati</li>
    </ol>
  </nav>

  <div class="row">
    <div class="col">
      <div class="inner-box p-4">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Carrier Name</label>
              <input type="text" id="carrierName" class="form-control" (blur)="carrierNameBlur()"
                     [ngClass]="{'is-invalid':carrierNameError}" [(ngModel)]="gatiList.connectionName"
                     [ngModelOptions]="{standalone: true}" placeholder="Carrier Name" required>
              <div id="carrierNameError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!carrierNameError" style="position: absolute;">
                {{carrierNameError}}
              </div>
            </div>


          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Customer Code</label>
              <input type="text" id="customerCode" class="form-control" (blur)="customerCodeBlur()"
                     [ngClass]="{'is-invalid':customerCodeError}" [(ngModel)]="gatiList.customerCode" [ngModelOptions]="{standalone: true}"
                     placeholder="Customer Code" required>
              <div id="customerCodeError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!customerCodeError" style="position: absolute;">
                {{customerCodeError}}
              </div>
            </div>

          </div>
          <div class="col-md-3 align-self-end">
            <div class="instr-box">
              <span>Gati Market Place Instructions </span>
              <svg xmlns="http://www.w3.org/2000/svg" width="17.14" height="17.14" viewBox="0 0 17.14 17.14">
                <path id="Icon_awesome-question-circle" data-name="Icon awesome-question-circle"
                      d="M17.7,9.132A8.57,8.57,0,1,1,9.132.563,8.569,8.569,0,0,1,17.7,9.132ZM9.362,3.4A4.476,4.476,0,0,0,5.335,5.6a.415.415,0,0,0,.094.562l1.2.909A.415.415,0,0,0,7.2,7c.617-.783,1.041-1.237,1.98-1.237.706,0,1.579.454,1.579,1.139,0,.518-.427.783-1.124,1.174C8.826,8.529,7.75,9.1,7.75,10.515v.138a.415.415,0,0,0,.415.415H10.1a.415.415,0,0,0,.415-.415v-.046c0-.984,2.875-1.024,2.875-3.686C13.389,4.916,11.31,3.4,9.362,3.4Zm-.23,8.57a1.59,1.59,0,1,0,1.59,1.59A1.591,1.591,0,0,0,9.132,11.966Z"
                      transform="translate(-0.563 -0.563)" fill="#c1c1c1"/>
              </svg>
            </div>
            <button class="btn btn-orange btn-block"  id="test" (click)="verify()">Test Connection & Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
